module.exports = __webpack_public_path__ + "img/machine.c2fc6994.png";